import React from 'react';
import { Link } from 'react-router-dom';

const Profile = () => {
    return (
        <>
            <section style={{ backgroundColor: '#eee' }}>
                <div className="container py-">
                    <div className="row">
                        <div className="col">
                            <nav aria-label="breadcrumb" className="bg-body-tertiary rounded-3 p-3">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/shopping">Shop</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">User Profile</li>
                                </ol>
                            </nav>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4">
                            <div className="card mb-4">
                                <div className="card-body text-center">
                                    <img
                                        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"
                                        alt="avatar"
                                        className="rounded-circle img-fluid"
                                        style={{ width: '150px' }}
                                    />
                                    <h5 className="my-3">John Smith</h5>
                                    <p className="text-muted mb-1">john@example.com</p>
                                    <p className="text-muted mb-4">Bay Area, San Francisco, CA</p>
                                </div>
                            </div>

                            {/* Social Links */}
                            {/* <div className="card mb-4 mb-lg-0">
                                <div className="card-body p-0">
                                    <ul className="list-group list-group-flush rounded-3">
                                        <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                            <i className="fas fa-globe fa-lg text-warning"></i>
                                            <p className="mb-0">https://mdbootstrap.com</p>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                            <i className="fab fa-github fa-lg text-body"></i>
                                            <p className="mb-0">mdbootstrap</p>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                            <i className="fab fa-twitter fa-lg" style={{ color: '#55acee' }}></i>
                                            <p className="mb-0">@mdbootstrap</p>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                            <i className="fab fa-instagram fa-lg" style={{ color: '#ac2bac' }}></i>
                                            <p className="mb-0">mdbootstrap</p>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                                            <i className="fab fa-facebook-f fa-lg" style={{ color: '#3b5998' }}></i>
                                            <p className="mb-0">mdbootstrap</p>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                        </div>

                        {/* Profile Details and Progress */}
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body">
                                    {[
                                        ['Full Name', 'Johnatan Smith'],
                                        ['Email', 'example@example.com'],
                                        ['Phone', '(097) 234-5678'],
                                        ['Mobile', '(098) 765-4321'],
                                        ['Address', 'Bay Area, San Francisco, CA'],
                                    ].map(([label, value]) => (
                                        <React.Fragment key={label}>
                                            <div className="row">
                                                <div className="col-sm-3"><p className="mb-0">{label}</p></div>
                                                <div className="col-sm-9"><p className="text-muted mb-0">{value}</p></div>
                                            </div>
                                            <hr />
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>

                            {/* Project Status Cards */}
                            {/* <div className="row">
                                {[1, 2].map((i) => (
                                    <div className="col-md-6" key={i}>
                                        <div className="card mb-4 mb-md-0">
                                            <div className="card-body">
                                                <p className="mb-4">
                                                    <span className="text-primary font-italic me-1">assignment</span> Project Status
                                                </p>
                                                {[
                                                    ['Web Design', 80],
                                                    ['Website Markup', 72],
                                                    ['One Page', 89],
                                                    ['Mobile Template', 55],
                                                    ['Backend API', 66],
                                                ].map(([task, progress]) => (
                                                    <React.Fragment key={task}>
                                                        <p className="mt-4 mb-1" style={{ fontSize: '.77rem' }}>{task}</p>
                                                        <div className="progress rounded" style={{ height: '5px' }}>
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{ width: `${progress}%` }}
                                                                aria-valuenow={progress}
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            ></div>
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Profile;
